<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}</label>
    <div class="">
      <CInput :type="type" :value="value" ref="refInput"
              @input="$emit('input', $event)"
              @keyup.enter="$emit('keyup-enter', $event)"
              autofocus
              :autocomplete="autocomplete"
              :invalid-feedback="invalidFeedback"
              :class="[extraClasses, {'is-invalid': isValid===false}, {'is-valid': isValid===true}, 'input-segmented']"
              :is-valid="isValid"
              :placeholder="placeholder">
        <template v-slot:prepend-content>
          <CIcon name="cipPasscodeLock"/>
        </template>
        <template v-slot:append-content>
          <span class="cursor-pointer" @click="toggleInputType">
            <CIcon :name="type === 'text' ? 'cip-eye': 'cip-eye-off' "/>
          </span>
        </template>
        <template v-slot:invalid-feedback>
          <slot name="invalid-feedback"></slot>
        </template>

      </CInput>


    </div>
  </div>
</template>

<script>
export default {
  name: "InputPassword",
  props: {
    value: {type: String, required: false},
    extraClasses: {type: String, required: false},
    placeholder: {type: String, required: false},
    autocomplete: {type: String, required: false},
    isValid: {type: Boolean, required: false},
    invalidFeedback: {type: String, required: false},
    label: {type: String, required: false}
  },
  data() {
    return {
      type: 'password'
    }
  },
  methods: {
    toggleInputType() {
      this.type === 'password' ? this.type = 'text' : this.type = 'password'
      this.$refs.refInput.$el.children[0].focus()
    }
  }
}
</script>
